// Externe Bibliotheken
import React, { Component } from 'react';
import _ from 'lodash';

// Interne Module
import { getSearchParams } from '@/_helper/searchParamsHelper';

// Styles
import './participants.scss';

class Participants extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checkedPersons: new Map(),
            searchParams: getSearchParams(),
            getCheckedPersons: 0,
            participants: [],
            travelType: props.travelType,
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.getCheckedPersons = this.getCheckedPersons.bind(this);
        this.getTravellers = this.getTravellers.bind(this);
    }

    componentDidMount() {
        this.getTravellers(this.props.travellers);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.participants !== this.state.participants) {
            this.getCheckedPersons();
        }
    }

    getTravellers(travellers) {
        if (travellers !== undefined) {
            travellers.forEach((traveller, key) => {
                if (this.state.searchParams) {
                    this.state.searchParams['p'].forEach((p) => {
                        if (parseInt(key) === parseInt(p)) {
                            travellers[key]['checked'] = true;
                        }
                    });
                } else {
                    _.forEach(travellers, function (v) {
                        _.assign(v, {
                            checked: true,
                        });
                    });
                }
            });
        }

        if (travellers !== undefined) {
            this.setState({
                participants: travellers,
            });
        }
    }

    getCheckedPersons() {
        let c = _.filter(this.state.participants, { checked: true });

        this.setState((prevState) => ({ getCheckedPersons: c }));

        this.props.getCheckedPersonsChange(c);
    }

    handleUserInput(event) {
        if (true) {
            const item = event.target.name;
            const isChecked = event.target.checked;
            const p = item.match(/\d/g)[0];
            const currentState = this.state;
            currentState.participants[p].checked = isChecked;

            this.setState((prevState) => ({ participants: currentState.participants }));

            this.getCheckedPersons();
        }
    }

    adults() {
        let dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

        let getAdults = _.filter(this.state.participants, function (o) {
            if (o === null) {
                return false;
            }
            return o.participantType === 'adult';
        });

        const items = [];

        Object.keys(getAdults).forEach((k) => {
            const { foreName, surName, dateOfBirth, checked } = getAdults[k];

            items.push(
                <div key={k} className="participant">
                    <div className="cnt">
                        <div className="name">
                            {foreName} {surName}
                        </div>
                        <div className="birthday">{new Date(dateOfBirth).toLocaleDateString('de-DE', dateOptions)}</div>
                        {this.state.travelType === 'excursion' && checked ? (
                            <div className="checked-selection">
                                <label className="entry">
                                    <input type="checkbox" checked={checked} readOnly={true} />
                                    <span className="checkbox-trigger"></span>
                                    {window.$browserInfo.device !== 'mobile' && <span>Teilnahme am Ausflug</span>}
                                </label>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </div>
            );
        });

        if (items.length === 0) {
            return false;
        }

        return (
            <div className="e adults">
                <div className="row">
                    <h3 className="title">Erwachsene</h3>
                    <div></div>
                    <div>{window.$browserInfo.device === 'mobile' && 'Ausflug'}</div>
                </div>
                {items}
            </div>
        );
    }

    childs() {
        let dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

        let getChilds = _.filter(this.state.participants, function (o) {
            if (o === null) {
                return false;
            }
            return o.participantType !== 'adult';
        });

        const items = [];

        Object.keys(getChilds).forEach((k) => {
            const { foreName, surName, dateOfBirth, checked } = getChilds[k];

            items.push(
                <div key={k} className="participant">
                    <div className="cnt">
                        {foreName} {surName}
                        <div className="birthday">{new Date(dateOfBirth).toLocaleDateString('de-DE', dateOptions)}</div>
                        {this.state.travelType === 'excursion' && checked ? (
                            <div className="checked-selection">
                                <label className="entry">
                                    <input type="checkbox" checked={checked} readOnly={true} />
                                    <span className="checkbox-trigger"></span>
                                </label>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </div>
            );
        });

        if (items.length === 0) {
            return false;
        }

        return (
            <div className="e childs">
                <h3 className="title">Kinder</h3>
                {items}
            </div>
        );
    }

    render() {
        return (
            <div className="sec participants">
                <div className="intro-line">
                    <div className="summary-headline">Reisende Personen</div>
                    <div
                        className="trigger"
                        onClick={(e) =>
                            e.target.closest('.sec').classList.contains('active')
                                ? ((e.target.innerHTML = 'mehr Details'),
                                  e.target.closest('.sec').classList.remove('active'))
                                : ((e.target.innerHTML = 'weniger Details'),
                                  e.target.closest('.sec').classList.add('active'))
                        }>
                        mehr Details
                    </div>
                </div>

                <div className="content">
                    <div className="entries">
                        {this.adults()}
                        {this.childs()}
                    </div>
                </div>
            </div>
        );
    }
}

export default Participants;
